module.exports = __webpack_public_path__ + "img/bag.8e475d4e.svg";